import { getLastDateOfPreviousYear } from "common/date-utils";
import { FromPeriods, LastPeriods, TimePeriods } from "store/current-dashboard/types";
export const defaultTimePeriodDisplayValues = {
    fromPeriod: FromPeriods.Inception,
    lastPeriod: LastPeriods.Months,
    lastPeriodStep: 3
};
export const fromPeriodDropdownOptions = [
    {
        values: [
            { displayValue: FromPeriods.Inception, isSelected: true, value: FromPeriods.Inception },
            { displayValue: FromPeriods.Year, value: FromPeriods.Year }
        ]
    }
];
export const lastPeriodDropdownOptions = [
    {
        values: [
            { displayValue: LastPeriods.Months, isSelected: true, value: LastPeriods.Months },
            { displayValue: LastPeriods.Quarters, value: LastPeriods.Quarters },
            { displayValue: LastPeriods.Years, value: LastPeriods.Years }
        ]
    }
];
const calculateStartDateForLastPeriodsMonths = (start, numberOfPeriods) => {
    // Define the end date as the current start date for comparison
    const end = new Date(start);
    // Define the endDay as the current day of the start date
    const endDay = end.getDate();
    // Subtract the number of months
    start.setMonth(start.getMonth() - numberOfPeriods);
    // Check if the day exists in the new month
    if (start.getDate() !== endDay) {
        // If the day doesn't exist, set to the last day of the previous month
        start.setDate(0);
    }
    // If the end date is the last day of the month, ensure the start date is also the last day
    if (end.getDate() === new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate()) {
        start.setDate(new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate());
    }
};
export const calculateStartAndEndDates = (numberOfPeriods, periodType, asOfDate) => {
    let start = new Date(asOfDate);
    switch (periodType) {
        case LastPeriods.Months:
            calculateStartDateForLastPeriodsMonths(start, numberOfPeriods);
            break;
        case LastPeriods.Quarters: {
            const asOfMonth = asOfDate.getMonth();
            const asOfQuarter = Math.floor(asOfMonth / 3);
            let targetQuarter = asOfQuarter - numberOfPeriods;
            let targetYear = asOfDate.getFullYear();
            while (targetQuarter < 0) {
                targetQuarter += 4;
                targetYear -= 1;
            }
            // 0th day of next month = last day of quarter
            const lastQuarterEndMonth = ((targetQuarter + 1) * 3) - 1;
            start = new Date(targetYear, lastQuarterEndMonth + 1, 0);
            break;
        }
        case LastPeriods.Years:
            start.setFullYear(start.getFullYear() - numberOfPeriods);
            break;
        default:
            break;
    }
    return { start };
};
export const getUpdatedDatesForTimePeriod = (eventData, asOfDate, lastPeriodStepper, lastPeriod, datepickerStartDate, datepickerEndDate, fromPeriod) => {
    if (eventData === TimePeriods.SpecifiedPeriodToAsOfDate) {
        return { startDateUpdated: fromPeriod === FromPeriods.Year && asOfDate ? getLastDateOfPreviousYear(asOfDate) : undefined };
    }
    else if (eventData === TimePeriods.LastSpecifiedPeriod) {
        const { start } = calculateStartAndEndDates(lastPeriodStepper || 3, lastPeriod || LastPeriods.Months, asOfDate || new Date());
        return { startDateUpdated: start };
    }
    else if (eventData === TimePeriods.FromDateToDate) {
        return { endDateUpdated: datepickerEndDate ? new Date(datepickerEndDate) : undefined,
            startDateUpdated: datepickerStartDate ? new Date(datepickerStartDate) : undefined };
    }
    return {};
};
